import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { FileText, Download, ExternalLink, X, FileImage, Receipt } from 'lucide-react';

const DocumentPreviewModal = ({ open, onOpenChange, belgeler = [], title = "Belgeler" }) => {
  if (!belgeler || belgeler.length === 0) return null;

  const handleDownload = (belge) => {
    const link = document.createElement('a');
    link.href = belge.url;
    link.download = belge.name || 'belge';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleOpenInNewTab = (belge) => {
    window.open(belge.url, '_blank');
  };

  const isPDF = (name) => name?.toLowerCase()?.endsWith('.pdf');
  const isImage = (name) => {
    const ext = name?.toLowerCase();
    return ext?.endsWith('.jpg') || ext?.endsWith('.jpeg') || ext?.endsWith('.png') || ext?.endsWith('.gif') || ext?.endsWith('.webp');
  };
  
  const getTypeColor = (type) => {
    switch(type) {
      case 'Kesilen Fatura': return 'bg-emerald-100 text-emerald-700';
      case 'Alınan Fatura': return 'bg-orange-100 text-orange-700';
      case 'Dekont': return 'bg-purple-100 text-purple-700';
      default: return 'bg-blue-100 text-blue-700';
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[700px] max-h-[90vh] overflow-y-auto" data-testid="document-preview-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileText className="h-5 w-5 text-blue-600" />
            {title} ({belgeler.length} belge)
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          {belgeler.map((belge, index) => (
            <div 
              key={index} 
              className="border rounded-lg p-4 bg-gray-50"
              data-testid={`document-item-${index}`}
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2 flex-wrap">
                  <FileText className="h-5 w-5 text-blue-600" />
                  <span className="font-medium text-sm">{belge.name || `Belge ${index + 1}`}</span>
                  {belge.type && (
                    <Badge className={getTypeColor(belge.type)}>
                      {belge.type}
                    </Badge>
                  )}
                  {belge.tarih && (
                    <span className="text-xs text-gray-500">{belge.tarih}</span>
                  )}
                </div>
                <div className="flex items-center gap-2">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => handleDownload(belge)}
                    title="İndir"
                    data-testid={`download-btn-${index}`}
                  >
                    <Download className="h-4 w-4 mr-1" />
                    İndir
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => handleOpenInNewTab(belge)}
                    title="Yeni sekmede aç"
                    data-testid={`open-tab-btn-${index}`}
                  >
                    <ExternalLink className="h-4 w-4 mr-1" />
                    Aç
                  </Button>
                </div>
              </div>
              
              {/* Preview Area */}
              {belge.url && (
                <div className="border rounded bg-white p-2">
                  {isImage(belge.name) || belge.url?.startsWith('data:image') ? (
                    <img 
                      src={belge.url} 
                      alt={belge.name || 'Belge'} 
                      className="max-w-full max-h-[300px] object-contain mx-auto"
                    />
                  ) : isPDF(belge.name) || belge.url?.includes('application/pdf') ? (
                    <div className="text-center py-8 text-gray-500">
                      <FileText className="h-12 w-12 mx-auto mb-2 text-red-500" />
                      <p className="text-sm">PDF dosyası</p>
                      <p className="text-xs text-gray-400">Görüntülemek için "Aç" butonuna tıklayın</p>
                    </div>
                  ) : (
                    <div className="text-center py-8 text-gray-500">
                      <FileText className="h-12 w-12 mx-auto mb-2" />
                      <p className="text-sm">Önizleme mevcut değil</p>
                      <p className="text-xs text-gray-400">İndirmek veya açmak için yukarıdaki butonları kullanın</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DocumentPreviewModal;
